<template>
  <div class="section-content">   
      <h2>Who is a suitable applicant for this route?</h2>
      
      <p>The Dialogue route is designed for colleagues whose role clearly indicates they are working at SF and above. Their day-to-day work will involve leading, managing, guiding, mentoring and/or training colleagues in HE teaching, to the benefit of students’ learning. Successful claimants on this route will be able to analyse their influence on colleagues, and draw on a range of illustrations in a relatively spontaneous way, in conversation with similarly experienced reviewers.</p>

      <p>Aspirant SFs with more limited experience of leadership in the HE learning and teaching area will usually find other routes preferable, due to the need to carefully consider and curate their reflections, possibly ‘teasing out’ the leadership aspect they can lay individual claim to, as part of an integrated role (also involving teaching, administrating, research etc). So if the colleague’s sphere of influence is not chiefly on other colleagues’ learning and teaching work, they might wish to consider a written account or formal presentation of their SF-level activities.</p>

      <h3>Reflective activity</h3>

      <p>Before mentoring a colleague for Senior Fellowship, think about: </p>
  </div>

    <div class="section-content-icons"> 

      <div class="">
        <div class="section-content-icon">
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.62 29.62">
            <polyline points="14.22 6.4 4.22 10.4 1.22 28.4 19.22 25.4 23.22 15.4" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
            <line x1="1.22" y1="28.4" x2="9.82" y2="19.8" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
            <rect x="18.12" y=".2" width="4.2" height="18.4" transform="translate(-.73 17.05) rotate(-45)" style="fill: none; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            <circle cx="11.22" cy="18.4" r="2" style="fill: none; stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
          </svg>
        </div>
        <div class="section-content-text">
            <p>Colleagues who enjoy oral presentation and / or who find reflective writing onerous may feel happier on one of the spoken routes, but ‘shy’ or more introverted claimants and/or those who enjoy writing will probably prefer the written option.</p>
        </div>
    </div>
  
    <div class="">
          <div class="section-content-icon">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 31.04">
              <path d="M4,1H28c1.66,0,3,1.34,3,3v15c0,1.66-1.34,3-3,3h-11l-9,7v-7H4c-1.66,0-3-1.34-3-3V4c0-1.66,1.34-3,3-3Z" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
          </div>
          <div class="section-content-text">
            <p>When guiding colleagues choosing between presentation (i.e. formal talk probably with prepared slides) or the dialogue route, consider if they have enough experience to respond ‘off the cuff’ to questions and comments from the panel regarding substantive and sustained leadership and teaching activities (2 years+).</p>
          </div>
    </div>
  </div>

      <div class="icon-section-three">
          <div class="section-content-icon">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="15" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
              <circle cx="16" cy="24.5" r="1.5"/>
              <path d="M12.91,7.79c2.79-1.24,6.41-1.09,7.65,.91s.38,4.32-1.74,6.12-2.82,2.77-2.82,4.18" style="fill: none;  stroke-linecap: square; stroke-miterlimit: 10; stroke-width: 2px;"/>
            </svg>
          </div>
          <div class="section-content-text">
            <p>Also think about efficiencies depending on individual circumstances: a formal presentation needs to be created, but on the other hand the dialogue requires two ‘practice runs’ with you, which will probably take an hour each.</p>
          </div>
      </div>

  <div class="section-content wysiwyg-hide">   

    <div class="section-question background-colour">
      <div class="question">   
        <p><b>Jot down some questions to ask in your initial meeting which will help clarify these aspects for the claimant.</b></p>
      </div>  
      <WYSIWYG :isEditing="isEditing" @submitQuestionOne = "saveText" />
    </div>
  </div>

</template>

<script>
import { ref } from '@vue/reactivity'
import { useQuasar } from 'quasar'
import WYSIWYG from '../WYSIWYGOne.vue'

export default {
  components: { WYSIWYG },
  setup() {

   const isEditing = ref(false) 

   const sessionMemory = useQuasar()

   const saveText = (save) => {
      sessionMemory.localStorage.set('questionOne', save)
      isEditing.value = !isEditing.value
      console.log(sessionMemory.localStorage.has('questionOne'))
   }

    return { isEditing, saveText, sessionMemory }
  }
}

</script>

<style scoped>

</style>